// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"164":"Importer","553":"TextEditor","596":"PDF"}[chunkId] || chunkId) + "." + {"164":"415e5e11","475":"1351b7bf","553":"83976adc","596":"bc9aca3d","767":"cf384aed","791":"eba0788d"}[chunkId] + ".chunk.js";
};